import React, { useState, useRef } from "react";

import Popover from "@mui/material/Popover";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";
import List from "@mui/material/List";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeDownIcon from "@mui/icons-material/VolumeDown";

import { Grid, Slider } from "@mui/material";

const NotificationsVolume = ({ volume, setVolume }) => {
    const theme = useTheme();
    const anchorEl = useRef();
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = () => {
        setIsOpen((prevState) => !prevState);
    };

    const handleClickAway = () => {
        setIsOpen(false);
    };

    const handleVolumeChange = (event, value) => {
        setVolume(value);
        localStorage.setItem("volume", value);
    };

    return (
        <>
            <IconButton
                sx={{
                    width: 34, height: 34, borderRadius: "9px",
                    color: theme.palette.mode === "dark" ? "rgba(255,255,255,0.55)" : "rgba(0,0,0,0.5)",
                    transition: "all 0.2s cubic-bezier(0.16,1,0.3,1)",
                    "&:hover": { background: "rgba(3,153,255,0.12)", color: "#38bdf8", transform: "translateY(-1px)" },
                }}
                onClick={handleClick}
                ref={anchorEl}
                aria-label="Open Notifications"
            >
                <VolumeUpIcon sx={{ fontSize: 17 }} />
            </IconButton>
            <Popover
                disableScrollLock
                open={isOpen}
                anchorEl={anchorEl.current}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                PaperProps={{
                    sx: {
                        width: "100%",
                        maxWidth: 350,
                        marginLeft: 2,
                        marginRight: 1,
                    }
                }}
                onClose={handleClickAway}
            >
                <List dense sx={{ padding: 2, minWidth: 250 }}>
                    <div style={{ alignItems: "center", display: "flex", gap: 16 }}>
                        <VolumeDownIcon sx={{ color: "grey.600", fontSize: "1.25rem" }} />
                        <div style={{ flex: 1, paddingLeft: 8, paddingRight: 8 }}>
                            <Slider
                                value={Number(volume)}
                                sx={{
                                    color: "primary.main",
                                    height: 6,
                                    "& .MuiSlider-track": { border: "none", height: 6 },
                                    "& .MuiSlider-thumb": {
                                        height: 16, width: 16, backgroundColor: "#fff",
                                        border: "2px solid currentColor", boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                        "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
                                            boxShadow: "0 3px 8px rgba(0,0,0,0.15)", height: 18, width: 18
                                        },
                                        "&:before": { display: "none" },
                                    },
                                    "& .MuiSlider-rail": { opacity: 1, height: 6 },
                                }}
                                aria-labelledby="volume-slider"
                                step={0.1}
                                min={0}
                                max={1}
                                onChange={handleVolumeChange}
                            />
                        </div>
                        <VolumeUpIcon sx={{ color: "grey.600", fontSize: "1.25rem" }} />
                    </div>
                </List>
            </Popover>
        </>
    );
};

export default NotificationsVolume;
